module.exports = __webpack_public_path__ + "finalytic-logo.png?e3bf95583f49392edf5c7281bb487024";